<script>
import { Table as ElTable } from 'element-ui'

export default {
  // Safari header/content misalign fix
  extends: ElTable,
  updated() {
    this.fixLayout()
  },

  methods: {
    /*
     * Method overidding, calls parent method to retain behaviour and then run a method
     * (fixLayout) to solve the misalignment issues  in safari.
     */
    doLayout(...args) {
      ElTable.methods.doLayout.call(this, ...args)
      this.fixLayout()
    },

    /*
     * fixLayout() loops through each of the table's columns and obtains there width. It
     * the proceeds to set the header of the column CSS style of min and max width equal
     * to the columns width where the offset width isn't equal to the columns width.
     *
     * The method then sets each of the columns cells min and max width to the columns
     * width where the offsetWidth is not equal to the columns.
     * */
    fixLayout() {
      this.columns.forEach(column => {
        // element-ui/packages/table/src/layout-observer.js:49
        const width = column.realWidth || column.width

        const th = this.$el.querySelector(
          `table.el-table__header th.${column.id}`
        )

        if (th) {
          if (th.offsetWidth !== width) {
            th.style = `min-width: ${width}px; max-width: ${width}px;`
          }

          let td
          for (td of this.$el.querySelectorAll(
            `table.el-table__body td.${column.id}`
          )) {
            if (td.offsetWidth === width) break

            td.style = `min-width: ${width}px; max-width: ${width}px;`
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/element/ElTable.vue